import { useEffect } from 'react';
import { Map as MaplibreMap } from 'maplibre-gl';

/**
 * Ascolta l'evento 'styledata' della mappa e chiama una funzione di callback
 * per segnalare che lo stile è cambiato e potrebbe essere necessaria una risincronizzazione.
 * @param map L'istanza della mappa MapLibre.
 * @param onStyleChanged Callback chiamata quando l'evento 'styledata' viene emesso.
 */
export function useMapStyleChangeSync(map: MaplibreMap | null, onStyleChanged: () => void) {
    useEffect(() => {
        if (!map) return;

        const handleStyleData = () => {
            onStyleChanged(); // Chiama la callback fornita
        };

        // Registra il listener
        map.on('idle', handleStyleData);

        // Funzione di cleanup per rimuovere il listener
        return () => {
            // Controlla se la mappa esiste ancora prima di rimuovere il listener
            if (map && map.getStyle()) { // getStyle() è un modo per verificare se la mappa è ancora valida
                try {
                    map.off('idle', handleStyleData);
                } catch (e) {
                }
            } else {
            }
        };
    }, [map, onStyleChanged]); // Dipende dalla mappa e dalla callback
}